import PageTemplate, { PageData } from "../../components/feature/sections/PageTemplate";
import { SERVICES, GIVING_BACK_IMAGE } from "../../mocks/siteData";

const locationData: PageData = {
  hero: {
    eyebrow: "3397 N 1200 E Suite 110 · Lehi, UT 84043",
    headline: "Experience Luxury at Our Lehi, Utah Studio",
    subheadline:
      "The Lash Bar is centrally located in Lehi, Utah — serving premium eyelash extensions, expert hair styling, and luxury tanning to clients from Salt Lake City and across Utah County.",
    primaryCTA: {
      label: "Get Directions",
      href: "https://goo.gl/maps/fMQvgKKY5mRxjqPA8",
      external: true,
    },
    secondaryCTA: {
      label: "Book Now",
      href: "https://dashboard.boulevard.io/booking/businesses/1dc117c9-31f1-49a3-9094-6719fd2f14a0/widget#/cart/menu",
      external: true,
    },
    bgImage:
      "https://public.readdy.ai/ai/img_res/1c190e73b02de270920eab3b6fc54c64.jpg",
  },

  services: {
    eyebrow: "At This Location",
    headline: "Everything We Offer in Lehi",
    subheadline:
      "Our Lehi studio delivers the full Lash Bar experience — voted Utah's best lash extensions alongside expert hair and luxury tanning, available seven days a week.",
    items: SERVICES,
  },

  aiBlock: {
    eyebrow: "What We Offer",
    headline: "Your Luxury Beauty Studio in Lehi, Utah",
    description:
      "The Lash Bar is located at 3397 N 1200 E Suite 110, Lehi, Utah 84043 — centrally positioned within Utah County and easily accessible from American Fork, Pleasant Grove, Highland, Eagle Mountain, Saratoga Springs, and the greater Salt Lake City area. Call (801) 473-2615.",
    whatWeDo: [
      {
        title: "Lash Extensions — Lehi, UT",
        text: "Utah County's premier destination for classic, volume, and hybrid lash extensions. Voted Utah's best lashes by Utah Valley Magazine — serving clients from Lehi, Salt Lake City, and all surrounding areas with 4.9-star precision artistry.",
      },
      {
        title: "Hair Services — Lehi, UT",
        text: "Expert hair stylists offering precision cuts, color treatments, balayage, blowouts, and wedding styling. Conveniently located in Lehi and trusted by clients from across Utah County and the greater Salt Lake City area.",
      },
      {
        title: "Tanning — Lehi, UT",
        text: "UV tanning beds, professional airbrush tanning, and infrared pod wellness sessions — all available at our Lehi studio for a radiant, personalized glow. Serving clients from all of Utah County.",
      },
      {
        title: "Boutique & Loyalty Program",
        text: "Shop Kérastase, RVCA, and Mangiacotti at our on-site boutique. Earn loyalty rewards points with every visit and service. The complete premium experience in one Lehi, Utah location.",
      },
    ],
    benefits: [
      { title: "Central Utah County Location", text: "Easy access from Lehi, American Fork, Highland, and Salt Lake City." },
      { title: "Ample On-Site Parking", text: "Suite 110 at 3397 N 1200 E offers convenient, hassle-free parking." },
      { title: "Open 7 Days a Week", text: "Monday–Friday from 9AM, Saturdays 9AM–4PM, Sundays 10AM–4PM." },
      { title: "Easy to Reach", text: "Call (801) 473-2615 or book online 24/7 — always accessible." },
    ],
  },

  process: {
    eyebrow: "Getting Here",
    headline: "How to Find Our Studio",
    steps: [
      {
        number: "01",
        title: "Head to Lehi",
        description: "We're at 3397 N 1200 E, easily accessible from I-15 and convenient for clients from Salt Lake City, American Fork, and all of Utah County.",
        icon: "ri-road-map-line",
      },
      {
        number: "02",
        title: "Find Suite 110",
        description: "Enter the building and locate Suite 110. On-site parking is ample and directly in front — getting here is simple and completely stress-free.",
        icon: "ri-building-line",
      },
      {
        number: "03",
        title: "Check In",
        description: "Our welcoming guest services team will greet you, confirm your appointment, and ensure your luxury experience begins the moment you arrive.",
        icon: "ri-checkbox-circle-line",
      },
      {
        number: "04",
        title: "Your Service",
        description: "Relax in our luxury studio while our certified artists deliver an exceptional, personalized service — crafted entirely for you, every single time.",
        icon: "ri-sparkling-2-line",
      },
    ],
  },

  whyChoose: {
    eyebrow: "Why Visit Us",
    headline: "Utah County's Premier Beauty Destination",
    items: [
      {
        icon: "ri-map-pin-line",
        title: "Prime Central Lehi Location",
        description: "Centrally located in Lehi — minutes from American Fork, Highland, Cedar Hills, Eagle Mountain, and Saratoga Springs. Easily accessible from the entire Utah County corridor.",
      },
      {
        icon: "ri-time-line",
        title: "Flexible Hours, 7 Days",
        description: "Open Monday through Sunday with extended Tuesday–Thursday hours until 8PM — designed for busy clients who need flexibility without compromising the luxury experience.",
      },
      {
        icon: "ri-award-line",
        title: "Utah's Most Awarded Studio",
        description: "Voted Utah's Best Lashes with a 4.9-star Google rating from 901 verified reviews. No other studio in Utah County has earned this level of client trust and recognition.",
      },
      {
        icon: "ri-phone-line",
        title: "Easy Access, Always",
        description: "Call (801) 473-2615 or book online 24/7. Our guest services team is ready to help you find the perfect time, service, and artist for your next appointment.",
      },
    ],
    image: GIVING_BACK_IMAGE,
  },

  serviceAreas: {
    eyebrow: "Serving the Wasatch Front",
    headline: "Serving Lehi, Utah and Surrounding Areas",
    description:
      "Clients drive from Salt Lake City, Provo, Draper, Riverton, and throughout Utah County for The Lash Bar experience. Premium lash extensions, hair, and tanning — worth every mile.",
  },

  testimonials: {
    eyebrow: "Utah County Reviews",
    headline: "Clients Love Our Lehi Studio",
  },

  faq: {
    eyebrow: "Location FAQ",
    headline: "Visiting The Lash Bar",
    items: [
      {
        question: "Where exactly is The Lash Bar located in Lehi, Utah?",
        answer:
          "The Lash Bar is at 3397 N 1200 E Suite 110, Lehi, UT 84043 — accessible from I-15 via the 1200 East corridor in north Lehi. Ample on-site parking is available directly in front of the building, making your arrival quick, easy, and stress-free.",
      },
      {
        question: "What are The Lash Bar's business hours?",
        answer:
          "Monday 9AM–7PM, Tuesday through Thursday 9AM–8PM, Friday 9AM–7PM, Saturday 9AM–4PM, and Sunday 10AM–4PM. Call (801) 473-2615 for same-day availability or book online at any time. We're open seven days a week for your convenience in Lehi.",
      },
      {
        question: "How do I get to The Lash Bar from Salt Lake City?",
        answer:
          "From Salt Lake City, take I-15 South toward Lehi — approximately 30 minutes. Exit at 2100 North Lehi and head east to 1200 E. The Lash Bar is at 3397 N 1200 E Suite 110. Straightforward, well-marked, and absolutely worth the drive for Utah's best lash studio.",
      },
      {
        question: "Is there parking available at The Lash Bar in Lehi?",
        answer:
          "Yes — convenient on-site parking is available directly in front of the building at 3397 N 1200 E, Lehi. Suite 110 is easily accessible from the main parking area. No parking stress — just arrive, check in, and enjoy your luxury beauty experience.",
      },
      {
        question: "How far is The Lash Bar from Orem or Provo?",
        answer:
          "The Lash Bar is approximately 15 to 20 minutes from Orem and 20 to 25 minutes from Provo via I-15 North. Many Utah County clients visit regularly from these cities for our premium lash extensions — consistently rated the best in all of Utah.",
      },
      {
        question: "Can I walk in without an appointment?",
        answer:
          "We strongly recommend booking in advance to secure your preferred time and artist — especially for lash extension appointments. Call us at (801) 473-2615 to check same-day availability or book online anytime. Walk-ins are accommodated when space allows.",
      },
    ],
  },

  finalCTA: {
    eyebrow: "Find Us in Lehi",
    headline: "Visit Our Utah Studio Today",
    subtext:
      "3397 N 1200 E Suite 110, Lehi, UT 84043 — open seven days a week. Serving Salt Lake City, Provo, American Fork, and all of Utah County. Call (801) 473-2615 or book online.",
  },
};

export default function LocationPage() {
  return <PageTemplate data={locationData} />;
}
